<div id="main-content" *ngIf="notification" [ngClass]="{ 'full-page': fullPage }">
	
	<!-- Navigation -->
	<div *ngIf="showNavigation" class="p-grid">
		<button pButton class="p-col nav-button p-button-secondary" label="Previous" (click)="previous()" icon="pi pi-arrow-left" [disabled]="!hasPrevious"></button>
		<button *ngIf="showShowAllButton" pButton class="p-col nav-button p-button-secondary" label="Show All" (click)="showAll()"></button>
		<button pButton class="p-col nav-button p-button-secondary" label="Next" (click)="next()" icon="pi pi-arrow-right" [disabled]="!hasNext" iconPos="right"></button>
	</div>

	<!-- Heading -->
	<div class="mb-1 text-center">
		<div>
			<h3>{{notification.subject}}</h3>
			<h5>{{notification.logName}} | {{notification.created | date:'MM/dd/yyyy HH:mm'}}</h5>
			<button pButton (click)="toggleRead(notification)" class="p-button-sm p-button-secondary p-m-1" [label]="notification.seen ? 'Mark Unread': 'Mark Read'" icon="pi pi-bell"></button>
		</div>
		<div class="btn-group">
			<button *ngIf="notification.note" pButton (click)="goToNote(notification.note)" class="p-button-sm p-m-1" label="Go to Note"></button>
			<button *ngIf="notification.fileAttachment && canPreviewFile(notification.fileAttachment)" pButton (click)="previewFile()" class="p-button-sm p-m-1" label="View" icon="pi {{getPreviewIcon()}}"></button>
			<button *ngIf="notification.fileAttachment" pButton (click)="downloadFile(notification.fileAttachment.id)" class="p-button-sm p-m-1" label="Download File" icon="pi pi-download"></button>
		</div>
	</div>

	<!-- Body -->
	<h4>Notification Message</h4>
	<div [innerHTML]="notification.message | trustHtml" class="well markdown-view note-table-note"></div>

</div>